<template>
    <el-menu class="el-menu-vertical-demo menu" active-text-color="rgba(117, 116, 249, 1)" unique-opened router :collapse="isCollapse">
     <template v-for="(item,i) in menuData" >
       <el-menu-item v-if="item.children === null" :index="item.menuUrl" >
         <span slot="title">{{item.menuName}}</span>
       </el-menu-item>
        <el-submenu v-else :key="i" :index="'submenu'+i">
          <template slot="title">
            <span>{{item.menuName}}</span>
          </template>
          <el-menu-item v-for="(menu_two,i) in item.children" :key="i" :index="menu_two.menuUrl" >
            <span>{{menu_two.menuName}}</span>
          </el-menu-item>
        </el-submenu>
      </template>
   </el-menu>
</template>
<script>
export default {
  name: 'systemMenu',
  data() {
    return {

    }
  },
  props: {
    menuData: {
      type: Array,
      default: () => {}
    },
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  created() {

  },
  methods:{

  },
  mounted (){
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  z-index: 98;
  font-size: 16px;
  font-weight: 600;
}

</style>



// WEBPACK FOOTER //
// src/common/menu.vue